// src/components/Toaster.tsx

"use client"

import { useToast } from "~/lib/use-toast"

import { Toast, ToastProvider, ToastViewport } from "./Toast"

const Toaster = (): JSX.Element => {
  const { toasts } = useToast()

  return (
    <ToastProvider swipeDirection="right">
      {toasts.map(({ id, ...props }) => {
        return <Toast key={id} {...props} />
      })}
      <ToastViewport />
    </ToastProvider>
  )
}

export { Toaster }
